import { render, staticRenderFns } from "./occuption-underwriting.vue?vue&type=template&id=ca08cd30&scoped=true&"
import script from "./occuption-underwriting.vue?vue&type=script&lang=js&"
export * from "./occuption-underwriting.vue?vue&type=script&lang=js&"
import style0 from "./occuption-underwriting.vue?vue&type=style&index=0&id=ca08cd30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca08cd30",
  null
  
)

export default component.exports